import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5, default as _styled6 } from "styled-components";
import React from "react";
import { graphql, useFragment, type FragmentType } from "~/gql/runtime";
import { Link } from "~/features/ui/link";
import { formatArticleTeaserDate } from "~/features/date/utils";
import { Media } from "~/features/ui/media";
import { Asset } from "~/features/craft/asset";
import { takeFirst } from "~/features/app/utils";
const fragment = graphql(`
  fragment ArticleTeaserWithImage on article_default_Entry {
    id
    url
    title
    date: postDate
    legacyImage: articleLegacyImage {
      ...Asset
    }
    hero {
      ... on hero_editorialHero_BlockType {
        media: baseMedia {
          ...Media
        }
      }
    }
  }
`);
type Props = FragmentType<typeof fragment> & {
  newWindow?: boolean;
};
export function ArticleTeaser(props: Props) {
  const {
    newWindow,
    ...rest
  } = props;
  const {
    url,
    title,
    date,
    id,
    hero,
    legacyImage
  } = useFragment(fragment, rest);
  const hoverId = `id-${id}`;
  const {
    media
  } = takeFirst(hero) || {};
  return <_StyledLink href={url} newWindow={newWindow} id={hoverId}>
      <_StyledDiv>
        <div>
          <_StyledDiv2>
            {media ? <Media {...takeFirst(media)} imageProps={{
            ratio: "1/1",
            fit: "cover",
            rounded: false
          }} externalVideoProps={{
            ratio: "1/1",
            fit: "cover"
          }} inlineVideoProps={{
            ratio: "1/1",
            fit: "cover"
          }} /> : <Asset asset={takeFirst(legacyImage)} imageProps={{
            ratio: "1/1",
            fit: "cover",
            rounded: false
          }} externalVideoProps={{
            ratio: "1/1",
            fit: "cover"
          }} inlineVideoProps={{
            ratio: "1/1",
            fit: "cover"
          }} />}
          </_StyledDiv2>
        </div>
        <_StyledDiv3>
          <_StyledSpan>
            {formatArticleTeaserDate(date)}
          </_StyledSpan>
          <_StyledP>
            {title}
          </_StyledP>
        </_StyledDiv3>
      </_StyledDiv>
    </_StyledLink>;
}
var _StyledLink = _styled(Link).withConfig({
  componentId: "sc-sf-yuqdps-0"
})({
  "display": "flex",
  "width": "100%",
  "alignItems": "center",
  "columnGap": "0.8rem",
  "borderRadius": "4px",
  "backgroundColor": "rgb(255 255 255 / 0.1)",
  "padding": "0.8rem",
  "--tw-backdrop-blur": "blur(24px)",
  "backdropFilter": "var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia)",
  "@media (min-width: 1024px)": {
    "height": "8rem"
  }
});
var _StyledDiv = _styled2("div").withConfig({
  componentId: "sc-sf-yuqdps-1"
})({
  "display": "flex",
  "width": "100%",
  "columnGap": "0.8rem"
});
var _StyledDiv2 = _styled3("div").withConfig({
  componentId: "sc-sf-yuqdps-2"
})({
  "position": "relative",
  "height": "6.4rem",
  "width": "5.6rem",
  "overflow": "hidden",
  "borderRadius": "2px"
});
var _StyledDiv3 = _styled4("div").withConfig({
  componentId: "sc-sf-yuqdps-3"
})({
  "display": "flex",
  "flex": "1 1 0%",
  "flexDirection": "column",
  "gap": "0.8rem"
});
var _StyledSpan = _styled5("span").withConfig({
  componentId: "sc-sf-yuqdps-4"
})({
  "whiteSpace": "nowrap",
  "fontFamily": "Aeonik, ui-serif, Georgia, Cambria, \"Times New Roman\", Times, serif",
  "fontSize": "1.2rem",
  "lineHeight": "1.1",
  "letterSpacing": "0.024rem",
  "fontWeight": "400",
  "color": "rgba(255, 255, 255, 0.5)",
  "@media (min-width: 1024px)": {
    "fontSize": "1.4rem",
    "lineHeight": "1.1",
    "letterSpacing": "0.028000000000000004rem",
    "fontWeight": "400"
  }
});
var _StyledP = /*#__PURE__*/_styled6("p").withConfig({
  displayName: "article-teaser___StyledP",
  componentId: "sc-1q0yyyb-0"
})({
  "width": "100%",
  "overflow": "hidden",
  "fontSize": "1.4rem",
  "lineHeight": "1.5",
  "letterSpacing": "0.014000000000000002rem",
  "fontWeight": "400",
  "WebkitBoxOrient": "vertical",
  "WebkitLineClamp": "2",
  "display": "-webkit-box",
  "@media (min-width: 1024px)": {
    "fontSize": "1.4rem",
    "lineHeight": "1.5",
    "letterSpacing": "0.014000000000000002rem",
    "fontWeight": "400"
  }
});